import { render } from "./InstallerOrders.vue?vue&type=template&id=2b693d62"
import script from "./InstallerOrders.vue?vue&type=script&lang=js"
export * from "./InstallerOrders.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matt/Local Sites/rhinodoors_dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__